import { RichTextEditor } from '@/components/common/RichTextEditor'
import type { FieldInputProps } from '../types'

export function RichTextInput({ value, onChange, disabled }: FieldInputProps) {
  return (
    <RichTextEditor
      value={value === null || value === undefined ? '' : String(value)}
      onChange={(html) => onChange(html)}
      disabled={disabled}
    />
  )
}
